export const fixEncoding = (str: string) => {
  return decodeURIComponent(escape(str));
};
